import React, {Component} from 'react';
import {Link} from "react-router-dom";

export class JobListing extends Component {

    state = {
        dateText: "",
        date: "",
        buttonLink: "",
        buttonText: ""
    };

    updateState = (job) => {
        switch (job.installationStatus) {
            case "UNASSIGNED":
                this.setState({
                    dateText: "production completed",
                    date: job.dates.productionComplete,
                    buttonLink: '/installation/assign',
                    buttonText: "Assign Job"
                });
                break;
            case "ASSIGNED":
                this.setState({
                    dateText: "job assigned",
                    date: job.dates.installerAssigned,
                    buttonLink: '/installation/view',
                    buttonText: "View Job"
                });
                break;
            case "COMPLETED":
                this.setState({
                    dateText: "installation completed",
                    date: job.dates.installationComplete,
                    buttonLink: '/installation/view',
                    buttonText: "View Job"
                });
                break;
            default:
                this.setState({
                    dateText: "job details unavailable",
                    date: "",
                    buttonLink: '/installation/view',
                    buttonText: "View Job"
                });
                break;
        }
    };

    componentDidMount() {
        this.updateState(this.props.job);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.job !== this.props.job) {
            this.updateState(this.props.job);
        }
    }

    render() {
        const { job, gradient } = this.props;
        const { dateText, date, buttonLink, buttonText } = this.state;
        return (
            <div className={`job-listing ${gradient ? "job-listing-gradient" : ""}`}>
                <div className={"job-listing-info"} key={job.ID}>
                    <h3>{job.name}</h3>
                    <p>{dateText} {date}</p>
                </div>
                <Link to={buttonLink} state={job}>
                    <button className="btn btn-primary" aria-label={job.ID}>{buttonText}</button>
                </Link>
            </div>
        );
    }
}
